export default "__VITE_ASSET__D5Ay7gaG__"